<template>
    <div class="sm:block hidden">
        <div class="py-8">
            <div class="border-iron-200 border-t"></div>
        </div>
    </div>
</template>
